export default __webpack_public_path__ + "images/UF.8bbbd78.png";